<template>
  <v-row>
      <v-col lg="6"  cols=12 style="padding-bottom:0px;">
        <s-crud
          title="Circuitos de Aprobacion"
          :config="config"
          :add="isCrud"
          :edit="isCrud"
          ref="gridAcc"
          :remove="isCrud"
          :filter="filter"
          @save="saveAcc($event)"  
          @rowSelected="rowSelected"
          searchInput
          :singleRow="singleRow"
        >
          <template v-slot:options>
            <v-btn icon @click="dialogReplace = true" title="Reemplazo Masivo de Puestos">
              <v-icon>mdi-account-convert</v-icon>
            </v-btn>
          </template>
          <template v-slot:filter>
            <v-container>
              <v-row class="justify-center">
                <v-col cols="4">
                  <s-select-area
                    v-model="filter.AreID"
                    label="Área"
                    clearable
                  />
                </v-col>
                <v-col cols="3">
                  <s-select-transaction
                    v-model="filter.TypeCircuit"
                    label="Tipo Circuito"
                    clearable
                  />
                </v-col>
                <v-col cols="3">
                  <v-switch
                    label="Circuitos activos"
                    v-model="filter.SecStatus"
                    dense
                    hide-details
                    :false-value="0"
                    :true-value="1"
                  />
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-if="isCrud" v-slot:default="{ item }">
            <v-container>
              <v-row justify="center">
                <v-col cols="7" class="s-col-form">
                  <s-text
                    v-model="item.AccName"
                    label="Nombre de Circuito"
                    autofocus
                  />
                </v-col>    
                <v-col cols="5" class="s-col-form">
                  <s-select-area
                    v-model="item.AreID"
                    label="Área"
                  />
                </v-col>
              </v-row>
              <v-row justify="center">
                 <v-col cols="4" class="s-col-form">
                  <s-select-transaction
                    v-model="item.TypeCircuit"
                    label="Tipo Circuito"
                  />
                </v-col>
                <v-col cols="2" class="s-col-form">
                  <s-date label="Fecha Inicio" v-model="item.AccBeginDate" />
                </v-col>
                <v-col cols="2" class="s-col-form">
                  <s-date clearable label="Fecha Fin" v-model="item.AccEndDate" />
                </v-col>
               

              <!--  <v-col cols="1" class="s-col-form">
                  <s-switch class="mt-2" label="Activo" v-model="item.SecStatus" />
                </v-col>-->
              </v-row>
            </v-container>
          </template>
          <template v-slot:SecStatus="{ row }">
            <v-icon :color="row.SecStatus == 1 ? 'success' : 'default'">
              mdi-checkbox-blank-circle</v-icon
            >
          </template>
        </s-crud>
        <v-divider></v-divider>
      </v-col>
      <v-col lg="6" >
        <s-autorize-detail :circuit=circuit v-if="parentID != 0" :parentID="parentID" />
      </v-col>

      <v-dialog v-model="dialogReplace" max-width="500px">
        <v-card>
          <v-card-title class="headline primary white--text">
            Reemplazo Masivo de Puestos
          </v-card-title>
          <v-card-text class="pt-4">
            <v-alert type="info" text dense>
              Reemplaza un puesto en todos los circuitos activos. Si dejas el nuevo puesto en blanco, el anterior será eliminado lógicamente y los niveles se reordenarán.
            </v-alert>
            <s-select-position
              label="Puesto a reemplazar (Obligatorio)"
              v-model="replaceForm.oldPstId"
              clearable
            />
            <s-select-position
              label="Nuevo Puesto (Opcional)"
              v-model="replaceForm.newPstId"
              clearable
              class="mt-4"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="dialogReplace = false">Cancelar</v-btn>
            <v-btn color="primary" :loading="loadingReplace" @click="executeMassiveReplace" :disabled="!replaceForm.oldPstId">Ejecutar Reemplazo</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-row>
</template>
<script>
import _sApprovalCircuit from "@/services/Security/ApprovalCircuitService";
import sAutorizeDetail from "./AutorizeDetail.vue";
import sSelectArea from "@/components/Utils/SSelectArea.vue";

export default {
  components: { sAutorizeDetail, sSelectArea },
  props: {
    singleRow: { type: Boolean, default: true },
    isCrud: { type: Boolean, default: true },
  },
  data() {
    return {
      acc: [],
      filter: {
        SecStatus: 1,
        TypeCircuit: 0,
        AreID: 0
      },
      parentID: 0,
      dialogReplace: false,
      loadingReplace: false,
      replaceForm: {
        oldPstId: 0,
        newPstId: 0
      },
    };
  },
  computed: {
    config() {
      return {
        model: {
          circuit:null,
          AccName: "string",
          AccID: "ID",
          AreID: "ID",
          AccBeginDate: "date",
          AccEndDate: "date",
          TypeCircuitText: "string",
          AreName: "string",
          SecStatus: "status",
        },
        service: _sApprovalCircuit,
        headers: this.isCrud
          ? [
              {
                text: "ID",
                value: "AccID",
                align: "end",
              },
              { text: "Circuito", value: "AccName" },
              { text: "Área", value: "AreName" },
              { text: "Tipo Circuito", value: "TypeCircuitText" },
              {
                text: "Fecha Inicio",
                value: "AccBeginDate",
              },
              {
                text: "Fecha Fin",
                value: "AccEndDate",
              },
              {
                width: "5%",
                text: "Sec",
                value: "SecStatus",
                sortable: false,
              },
            ]
          : [
              {
                text: "ID",
                value: "AccID",
                align: "end",
              },
              { text: "Circuito", value: "AccName" },
              { text: "Área", value: "AreName" },
            ],
      };
    },
  },
  methods: {
    rowSelected(rows) {
      if (rows.length > 0) {
      this.circuit=rows[0];
        this.parentID = rows[0].AccID;
      }
    },

    validatedCircuit(item) {
      let isValid = false;
      let message = "";

      isValid = item.AccName.length > 0;
      if (!isValid) message = "Ingrese Nombre de Circuito";
      else {
        isValid = item.AccBeginDate;
        if (!isValid) message = "Ingrese Fecha de Inicio Circuito";
        else {
        }
      }

      if (!isValid) this.$fun.alert(message, "warning");

      return isValid;
    },
    saveAcc(item) {
      if (this.validatedCircuit(item)) {
        item.save();
      }
    },
    executeMassiveReplace() {
      if (!this.replaceForm.oldPstId) {
        this.$fun.alert("Seleccione el puesto a reemplazar", "warning");
        return;
      }
      
      const msg = this.replaceForm.newPstId 
        ? "¿Está seguro de reemplazar este puesto masivamente en los circuitos activos?" 
        : "No seleccionó nuevo puesto. ¿Está seguro de ELIMINAR lógicamente el puesto de todos los circuitos?";
        
      if (confirm(msg)) {
        this.loadingReplace = true;
        let newPst = this.replaceForm.newPstId ? this.replaceForm.newPstId : null;
        
        _sApprovalCircuit.massiveReplace(this.replaceForm.oldPstId, newPst, this.$fun.getUserID())
        .then(() => {
          this.$fun.alert("Reemplazo masivo completado con éxito", "success");
          this.dialogReplace = false;
          this.replaceForm = { oldPstId: 0, newPstId: 0 };
          if (this.$refs.gridAcc) {
            this.$refs.gridAcc.getList(); // recargar grid
          }
          if (this.parentID > 0) {
            // refresh child tabs by toggling parentID
            let id = this.parentID;
            this.parentID = 0;
            setTimeout(() => { this.parentID = id; }, 100);
          }
        }).catch(err => {
          this.$fun.alert("Error en el reemplazo masivo: " + err, "error");
        }).finally(() => {
          this.loadingReplace = false;
        });
      }
    },
  },
  mounted() {
    this.filter.TypeCircuit = 0;
    this.filter.AreID = 0;
  },
  watch: {
    'filter.TypeCircuit'(val) {
      if (val === null) {
        this.filter.TypeCircuit = 0;
      }
    },
    'filter.AreID'(val) {
      if (val === null) {
        this.filter.AreID = 0;
      }
    }
  }

};
</script>
